import { render, staticRenderFns } from "./NuevoCambioActivoCliente.vue?vue&type=template&id=2dc6deb2&"
import script from "./NuevoCambioActivoCliente.vue?vue&type=script&lang=ts&"
export * from "./NuevoCambioActivoCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2dc6deb2', component.options)
    } else {
      api.reload('2dc6deb2', component.options)
    }
    module.hot.accept("./NuevoCambioActivoCliente.vue?vue&type=template&id=2dc6deb2&", function () {
      api.rerender('2dc6deb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/CambiosServicio/NuevoCambioActivoCliente.vue"
export default component.exports